import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';

export const loader = ImmutablePropTypes.contains({
  loading: PropTypes.bool
});

export const loaderActions = PropTypes.object;
